import React from "react";
import { CopyToClipboard } from "../../../../../components";

const CopyToClipboardList = () => {
  return (
    <div className="m-5 flex flex-1 justify-center items-center">
      <div className="flex items-center gap-0.5">
        <CopyToClipboard
          title={"Link is"}
          content={"https://tektreeinc.com/"}
        />
        <p className="text-linkblue text-sm">https://tektreeinc.com/</p>
      </div>
    </div>
  );
};

export default CopyToClipboardList;
